import React from "react";
import "./TrainingAzureSearchRootComponent.scss"
import CustomButton from "../../../../components/commons/custom-button/custom-button.component";
import { trinityTrainingDateFormatter,trinitySearchTrainingDateFormatter } from "../../../../utilities/CommonUtilities";
import { TrainingSearchSiteType } from "../../../../components/commons/enum/enum";

const TrainingAzureSearchPostElement = ({ element }) => {
    const processName = (individualObject) => {
        if (individualObject["City"]?.length > 0 && individualObject["State"]?.length > 0) {
            return individualObject["City"] + ", " + individualObject["State"]
        } else if (individualObject["City"]?.length > 0) {
            return individualObject["City"]
        } else if (individualObject["State"]?.length > 0 && individualObject["State"] === "ZZ NOT FOUND") {
            return ""
        } else if (individualObject["State"]?.length > 0) {
            return individualObject["State"]
        } else {
            return ""
        }

    }

    const onClickLearnMore = () => {
        window.open("/training/" + element[0].SKU + "/" + element[0].DisplayName.replace(/\s+|\+/g, '-').replace(/\//g, '-'), "_blank")
    }

    var sitedata = element[0] && element[0].SiteId != undefined && element[0].SiteId != null && element[0].SiteId != "" ?
        element[0].SiteId.split(",") : null;

    var isSafebridge = sitedata !== null && sitedata.find(x => parseInt(x) === 3) != undefined && Object.keys(sitedata.find(x => parseInt(x) === 3)).length > 0 ? true : false;

    return (
        <div className="widgetBox-wrapper">
            <div className="widget-wrapper">
                <div>
                    {/* <div className="tags-container">
                        <ul>
                            <>
                                {sitedata.map((item, index) => {
                                    return (
                                        <li className="list-item" key={index}>
                                            {parseInt(item) == 0 && "TrinityConsultants"}
                                            {parseInt(item) == TrainingSearchSiteType.TrinityConsultants && "TrinityConsultants"}
                                            {parseInt(item) == TrainingSearchSiteType.Breeze && "Breeze"}
                                            {parseInt(item) == TrainingSearchSiteType.SafeBridge && "SafeBridge"}
                                        </li>
                                    )
                                })}
                            </>
                        </ul>
                    </div> */}
                </div>

                <div className="class-dec">
                    <div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {/*KT change tag h1 to P and add new class for styling */}
                            <h1 className={"training-post-heading"}>
                                {element[0]?.DisplayName}
                            </h1>
                            {/* <p className={"post-heading-sub-title"}>Upcoming time & location</p> */}
                            {isSafebridge === true && <p className={"post-heading-sub-title"}>Business Unit : SafeBridge</p>}
                        </div>
                    </div>

                    <div>
                        <div>
                            <CustomButton onClick={onClickLearnMore} title={"Learn More"} />
                        </div>
                    </div>
                </div>

                <div className={"bottom-row-card-container"}>
                    {
                        element.map((individualObject, index) => {
                            return (
                                <div key={index} className={"classroom"}>
                                    <h1 className="class-name">
                                        {individualObject["ByFormat"] === "Complimentary" ? "Webinar" : individualObject["ByFormat"]}
                                    </h1>
                                    {
                                        individualObject["ByFormat"] !== "OnDemand"
                                            ? <>
                                                <p className="class-date">
                                                    {
                                                        trinitySearchTrainingDateFormatter(individualObject["EndDate"]) === trinitySearchTrainingDateFormatter(individualObject["DatePublished"])
                                                            ? individualObject["ByFormat"] === "Complimentary" && individualObject["DatePublished"].startsWith("999")
                                                                ? "Online"
                                                                : trinitySearchTrainingDateFormatter(individualObject["DatePublished"])
                                                            : trinitySearchTrainingDateFormatter(individualObject["DatePublished"]) + "-" + trinitySearchTrainingDateFormatter(individualObject["EndDate"])
                                                    }
                                                </p>
                                                <p className="class-date">
                                                    {processName(individualObject)}
                                                </p>
                                            </>
                                            : <p className="class-date">
                                                Online
                                            </p>
                                    }

                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <hr />
        </div>
    )
}

function TrainingAzureSearchPostList({ valueList, activePage }) {
    return (
        <div className="training-posts-container">
            {
                valueList && valueList.slice((activePage * 10) - 10, activePage * 10)
                    .map(element => {
                        return (
                            <TrainingAzureSearchPostElement element={element} />
                        )
                    })
            }
        </div>
    );
}

export default TrainingAzureSearchPostList;
